// extracted by mini-css-extract-plugin
export default {"root":"DownloadCreditNotePdfButton_root__8r9E+"};